<div class="food__content p-3">
  <div class="food__content-items">
    <div class="food__content-img">
      <img *ngIf="isImageValid(meal?.imageUrl)" [src]="meal?.imageUrl" [alt]="meal?.name" />
      <img *ngIf="!isImageValid(meal?.imageUrl)" src="/assets/images/no-food-img.svg" [alt]="meal?.name" />
    </div>

    <div class="d-flex flex-column">
      <p class="secondary-font-medium mb-0">{{ meal?.name }}</p>
      <div class="flex-row align-items-center mb-1">
        <span class="f-14 primary-font-normal mb-0">{{ meal?.price | currency : '₦' }}</span>
        <span class="f-14 primary-font-normal">&nbsp; &#x2022; &nbsp; x{{ meal?.quantityOrdered }}</span>
      </div>
      <!-- Show takeout checkbox only when not in success page -->
      <div *ngIf="orderPreference === 'dine-in' && meal.takeawayPrice && !isSuccessPage">
        <div class="d-flex align-items-center">
          <input type="checkbox" [(ngModel)]="meal.takeout" class="check-custom mr-2" (ngModelChange)="onTakeoutChange()" />
          <span class="f-14 text-gray-600">
            Takeout
          </span>
        </div>
      </div>
      <!-- Show takeaway price only in success page when takeout is true -->
      <div *ngIf="isSuccessPage && meal.takeout && meal.takeawayPrice" class="mt-1">
        <span class="f-14 primary-font-normal">
          Takeaway Price: {{ meal.takeawayPrice | currency : '₦' }}
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="!isSuccessPage" class="food__content-edit text-right">
    <img [matMenuTriggerFor]="beforeMenu" src="/assets/icons/menu-opener.svg" alt="edit" />
  </div>
</div>



<div class="food__addons p-3" [ngClass]="{ 'success-pg': isSuccessPage }"
  *ngIf="meal?.addOns && meal?.addOns?.length > 0">
  <p class="f-13 primary-font-normal text-gray-500">ADD-ONS</p>
  <ng-container *ngFor="let item of meal?.addOns">
    <div class="d-flex mb-2 flex-row justify-content-between">
      <div class="addon">
        <p class="f-14 primary-font-normal mb-0">
          <span class="text-gray-500">&#43;</span>
          {{ item?.name }}
        </p>
      </div>

      <p class="f-14 primary-font-normal mb-0">
        {{ item?.price | currency : '₦' }}
      </p>
    </div>
  </ng-container>
</div>



<mat-menu #beforeMenu="matMenu" xPosition="before">
  <button mat-menu-item class="px-2" (click)="onActionSelection(meal, 'edit')">
    <span class="p-menu-item">
      <img src="/assets/icons/edit-meal-item.svg" alt="edit" />
      <span class="text-gray-600 primary-font-normal f-14 ml-3 pr-5">Edit item</span>
    </span>
  </button>
  <button mat-menu-item class="px-2" (click)="onActionSelection(meal, 'delete')">
    <span class="delete-area p-menu-item">
      <img src="/assets/icons/delete-meal-item.svg" alt="delete" />
      <span class="f-14 ml-3 text-error-500 primary-font-normal pr-5">Delete item</span>
    </span>
  </button>
</mat-menu>